// MindForge web — Rule Switch sorting logic (TS port of logic/rules.py).

export interface SortableCard {
  colorIndex: number;
  shapeIndex: number;
  count: number;
}

export type SortRule = "color" | "shape" | "count";

/**
 * Whether `target` matches `card` on the given sorting rule.
 *
 * The count dimension is intentionally ambiguous: the four Rule Switch
 * targets carry counts [1, 2, 3, 1] (four targets, only three possible
 * counts), so a count-1 card matches TWO targets. A sort must therefore be
 * judged correct when the chosen target matches the active rule — accepting
 * ANY matching target, never just the first one found.
 */
export function cardMatches(
  target: SortableCard,
  card: SortableCard,
  rule: SortRule,
): boolean {
  switch (rule) {
    case "color":
      return target.colorIndex === card.colorIndex;
    case "shape":
      return target.shapeIndex === card.shapeIndex;
    case "count":
      return target.count === card.count;
  }
}
